var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{style:(_vm.styles),attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"offset":_vm.offset,"offset-sm":_vm.offsetSm,"order":_vm.order,"order-sm":_vm.orderSm}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }